import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Modal from '../../../Modal';
import Tooltip from '../../../Tooltip';
import { SCHEDULED_EXPORTS_LIMIT } from '../../configs/constants';

const trialTTContent =
  'Advanced export settings cannot be saved during your trial period. You can continue with a one-time export';
const scheduledLimitTTContent = `You have reached your maximum allowed scheduled exports (${SCHEDULED_EXPORTS_LIMIT})`;

const ExportTypeSelectionModal = ({
  open,
  isSaveDisabled,
  isScheduled,
  scheduleLimitReached,
  onOneTimeSelect,
  onExportAndSaveSelect,
  onScheduleSelect,
  onScheduleUpdateSelect,
  onClose,
}) => (
  <Modal
    open={open}
    size="xs"
    hideCloseButton
    shouldCloseOnOverlayClick
    modalClassName="export-type-selection-modal"
    onClose={onClose}
  >
    <p className="eyebrow text-center">Select Export Type</p>
    <div className="export-type-selection-actions">
      <div className="export-type-selection-action" onClick={() => onOneTimeSelect()}>
        <h3 className="h3">One-Time Export</h3>
        <p className="export-type-selection-action-description">
          Single export that will not be used in the future
        </p>
      </div>
      <Tooltip content={isSaveDisabled && trialTTContent} colorVariant="light">
        <div
          className={cx('export-type-selection-action', { disabled: isSaveDisabled })}
          onClick={() => !isSaveDisabled && onExportAndSaveSelect()}
        >
          <h3 className="h3">Export & Save</h3>
          <p className="export-type-selection-action-description">
            Generate export and save settings for future use.
          </p>
        </div>
      </Tooltip>
      <Tooltip
        content={(() => {
          if (isSaveDisabled) return trialTTContent;
          if (scheduleLimitReached && !isScheduled) return scheduledLimitTTContent;
          return null;
        })()}
        colorVariant="light"
      >
        <div
          className={cx('export-type-selection-action', {
            disabled: isSaveDisabled || (scheduleLimitReached && !isScheduled),
          })}
          onClick={() => {
            if (isSaveDisabled) return;

            if (isScheduled) onScheduleUpdateSelect();
            else if (!scheduleLimitReached) onScheduleSelect();
          }}
        >
          <h3 className="h3">{isScheduled ? 'Modify Schedule' : 'Schedule Export'}</h3>
          <p className="export-type-selection-action-description">
            {isScheduled
              ? 'Modify your existing scheduled export settings'
              : 'Scheduled export that will run automatically on a chosen cadence'}
          </p>
        </div>
      </Tooltip>
    </div>
  </Modal>
);

ExportTypeSelectionModal.propTypes = {
  open: T.bool.isRequired,
  isSaveDisabled: T.bool,
  isScheduled: T.bool,
  scheduleLimitReached: T.bool,
  onOneTimeSelect: T.func.isRequired,
  onExportAndSaveSelect: T.func.isRequired,
  onScheduleSelect: T.func.isRequired,
  onScheduleUpdateSelect: T.func.isRequired,
  onClose: T.func.isRequired,
};

export default ExportTypeSelectionModal;
